import { memo } from 'react';
import { Field } from './Field';
import { SolidHomeHouseIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

interface ISelectOfficeProps {
  value: string;
  isDisabled?: boolean;
}

const Component = ({ isDisabled = false, value }: ISelectOfficeProps) => (
  <Field
    ComponentProps={{
      Button: { 'data-cy': 'select-office-trigger', 'data-testid': 'select-office-trigger' },
      Container: { 'data-cy': 'select-office', 'data-testid': 'select-office' },
    }}
    IconSrc={<SolidHomeHouseIcon size={24} color={colors.secondary[500]} />}
    isDisabled={isDisabled}
    title="Office:"
    value={value}
  />
);

export const SelectOffice = memo(Component);
